var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 17235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 47 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8745 8.13593C17.0418 8.31717 17.0418 8.61101 16.8745 8.79225L10.3439 15.8641C10.1765 16.0453 9.90514 16.0453 9.73777 15.8641L7.12553 13.0353C6.95816 12.8541 6.95816 12.5603 7.12553 12.379C7.29289 12.1978 7.56425 12.1978 7.73162 12.379L10.0408 14.8796L16.2684 8.13593C16.4358 7.95469 16.7071 7.95469 16.8745 8.13593Z",
    fill: "#2CAAE2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 216",
    cx: 12,
    cy: 12,
    r: 9.4,
    stroke: "#2CAAE2",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryTick);
export default __webpack_public_path__ + "static/media/primary_tick.7eaad69ceb1b4bbb365f719dd20642fb.svg";
export { ForwardRef as ReactComponent };